import { getFunctions, httpsCallable } from 'firebase/functions';

const functions = getFunctions();

class DescriptionGenerator {
  async generateDescription(jobTitle, company, fullJobPost) {
    try {
      const generateJobDescription = httpsCallable(functions, 'generateJobDescription');
      const result = await generateJobDescription({ jobTitle, company, fullJobPost });
      
      if (result.data.success) {
        return result.data.description;
      } else {
        throw new Error(result.data.error || 'Failed to generate description');
      }
    } catch (error) {
      console.error('Error generating description:', error);
      // ✅ Your original fallback
      return `Exciting opportunity to work as a ${jobTitle} at ${company}. We're looking for qualified candidates to join our team.`;
    }
  }

  // ✅ Your original logic
  isDescriptionEmpty(description) {
    return !description || 
           description.trim() === '' || 
           description.trim().toLowerCase() === 'n/a' ||
           description.trim().toLowerCase() === 'none' ||
           description.trim().toLowerCase() === 'tbd' ||
           description.trim().toLowerCase() === 'to be determined';
  }
}

export default new DescriptionGenerator();